"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DealPriceType_1 = require("../enum/DealPriceType");
var OptionsType_1 = require("../enum/OptionsType");
var dealPriceAccessor = {
    // Currently, this service is being implemented in Checkout Lite
    // It should be implemented everywhere where we process the deal prices.
    getFittedPrice: function (prices) {
        return prices.find(function (price) {
            return price.type === DealPriceType_1.DealPriceType.FITTED;
        });
    },
    getCarPriceByType: function (prices, priceType) {
        return prices.find(function (price) { return price.type.toLowerCase() === priceType.toLowerCase(); }) || null;
    },
    getPrimaryPrice: function (prices, priceDisplay) {
        var _a;
        return (_a = prices) === null || _a === void 0 ? void 0 : _a.find(function (price) {
            var _a, _b;
            return (((_a = price) === null || _a === void 0 ? void 0 : _a.currency) === ((_b = priceDisplay.primary) === null || _b === void 0 ? void 0 : _b.currency))
                && (price.type === priceDisplay.primary.type || price.type === DealPriceType_1.DealPriceType.FITTED);
        });
    },
    getSecondaryPrice: function (prices, priceDisplay) {
        var _a;
        return (_a = prices) === null || _a === void 0 ? void 0 : _a.find(function (price) {
            var _a, _b;
            return (((_a = price) === null || _a === void 0 ? void 0 : _a.currency) === ((_b = priceDisplay.secondary) === null || _b === void 0 ? void 0 : _b.currency)) &&
                (price.type === priceDisplay.secondary.type || price.type === DealPriceType_1.DealPriceType.FITTED);
        });
    },
    isMultiCurrency: function (priceDisplay) {
        var _a, _b;
        return dealPriceAccessor.hasSecondaryCurrency(priceDisplay) && ((_a = priceDisplay.primary) === null || _a === void 0 ? void 0 : _a.currency) !== ((_b = priceDisplay.secondary) === null || _b === void 0 ? void 0 : _b.currency);
    },
    // @TODO This has nothing to do with deal. Factor out to avoid unnecessary coupling.
    hasSecondaryCurrency: function (priceDisplay) {
        var _a;
        return !!((_a = priceDisplay) === null || _a === void 0 ? void 0 : _a.secondary);
    },
    getPrimaryOptionsPrices: function (prices, priceDisplay) {
        var _a;
        return ((_a = prices) === null || _a === void 0 ? void 0 : _a.filter(function (price) {
            var _a;
            return (price.type === DealPriceType_1.DealPriceType.FITTED || price.type === DealPriceType_1.DealPriceType.FINAL_PRICE) &&
                (price.currency === ((_a = priceDisplay) === null || _a === void 0 ? void 0 : _a.primary.currency));
        })) || null;
    },
    getSecondaryOptionsPrices: function (prices, priceDisplay) {
        var _a;
        return ((_a = prices) === null || _a === void 0 ? void 0 : _a.filter(function (price) {
            var _a;
            return (price.type === DealPriceType_1.DealPriceType.FITTED || price.type === DealPriceType_1.DealPriceType.FINAL_PRICE) &&
                (price.currency === ((_a = priceDisplay.secondary) === null || _a === void 0 ? void 0 : _a.currency));
        })) || null;
    },
    getCarOptionsByTypes: function (carOptions, optionsType) {
        var _a;
        return (_a = carOptions) === null || _a === void 0 ? void 0 : _a.filter(function (option) {
            return optionsType.includes(option.category.category.toLowerCase());
        });
    },
    getAccessoriesTotalPrice: function (carConfiguration, priceDisplay) {
        var _a, _b;
        var options = dealPriceAccessor.getCarOptionsByTypes((_a = carConfiguration) === null || _a === void 0 ? void 0 : _a.options, [OptionsType_1.OptionsType.ACCESSORIES, OptionsType_1.OptionsType.ACCESSORIES_PACK]);
        if (!((_b = options) === null || _b === void 0 ? void 0 : _b.length)) {
            return null;
        }
        return options.reduce(function (previous, current) {
            var fittedPrices = dealPriceAccessor.getPrimaryOptionsPrices(current.prices, priceDisplay);
            if (!fittedPrices.length) {
                return previous;
            }
            return previous + fittedPrices.reduce(function (current2, price) { return current2 + price.basePrice; }, 0);
        }, 0);
    },
    getCarPricesByType: function (prices, priceType) {
        var _a;
        return (_a = prices) === null || _a === void 0 ? void 0 : _a.filter(function (price) { return price.type.toLowerCase() === priceType.toLowerCase(); });
    },
    getAccessoriesTotalGovChargesPrice: function (carOptions) {
        var _a, _b;
        var options = dealPriceAccessor.getCarOptionsByTypes(carOptions, [OptionsType_1.OptionsType.ACCESSORIES, OptionsType_1.OptionsType.ACCESSORIES_PACK]);
        if (!((_a = options) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        return (_b = options) === null || _b === void 0 ? void 0 : _b.reduce(function (previous, current) {
            var fittedPrices = dealPriceAccessor.getCarPricesByType(current.prices, DealPriceType_1.DealPriceType.FITTED);
            if (!fittedPrices.length) {
                return previous;
            }
            return previous + fittedPrices.reduce(function (current2, price) { return current2 + price.governmentCharges; }, 0);
        }, 0);
    },
    getServicePlanPrice: function (options, priceDisplay) {
        var _a;
        var servicePlanOptions = dealPriceAccessor.getCarOptionsByTypes(options, [OptionsType_1.OptionsType.SERVICE_PLAN]);
        if (!((_a = servicePlanOptions) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        return servicePlanOptions.reduce(function (previous, current) {
            var basePrice = dealPriceAccessor.getPrimaryPrice(current.prices, priceDisplay);
            return previous + (basePrice ? basePrice.basePrice : 0);
        }, 0);
    },
    getPrimaryOptionsPrice: function (carConfiguration, priceDisplay) {
        var _a, _b;
        return (dealPriceAccessor.getAccessoriesTotalPrice(carConfiguration, priceDisplay) || 0) +
            (dealPriceAccessor.getAccessoriesTotalGovChargesPrice((_a = carConfiguration) === null || _a === void 0 ? void 0 : _a.options) || 0) +
            (this.getServicePlanPrice((_b = carConfiguration) === null || _b === void 0 ? void 0 : _b.options, priceDisplay) || 0);
    },
    getSecondaryAccessoriesTotalPrice: function (carConfiguration, priceDisplay) {
        var _a, _b;
        var options = dealPriceAccessor.getCarOptionsByTypes((_a = carConfiguration) === null || _a === void 0 ? void 0 : _a.options, [OptionsType_1.OptionsType.ACCESSORIES, OptionsType_1.OptionsType.ACCESSORIES_PACK]);
        if (!((_b = options) === null || _b === void 0 ? void 0 : _b.length)) {
            return null;
        }
        return options.reduce(function (previous, current) {
            var fittedPrices = dealPriceAccessor.getSecondaryOptionsPrices(current.prices, priceDisplay);
            if (!fittedPrices.length) {
                return previous;
            }
            return previous + fittedPrices.reduce(function (current2, price) { return current2 + price.basePrice; }, 0);
        }, 0);
    },
    getSecondaryServicePlanPrice: function (options, priceDisplay) {
        var _a;
        var servicePlanOptions = dealPriceAccessor.getCarOptionsByTypes(options, [OptionsType_1.OptionsType.SERVICE_PLAN]);
        if (!((_a = servicePlanOptions) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        return servicePlanOptions.reduce(function (previous, current) {
            var fittedPrices = dealPriceAccessor.getSecondaryOptionsPrices(current.prices, priceDisplay);
            if (!fittedPrices.length) {
                return previous;
            }
            return previous + fittedPrices.reduce(function (current2, price) { return current2 + price.basePrice; }, 0);
        }, 0);
    },
    getSecondaryOptionsPrice: function (carConfiguration, priceDislay) {
        var _a;
        return (dealPriceAccessor.getSecondaryAccessoriesTotalPrice(carConfiguration, priceDislay) || 0) +
            (dealPriceAccessor.getSecondaryServicePlanPrice((_a = carConfiguration) === null || _a === void 0 ? void 0 : _a.options, priceDislay) || 0);
    },
    getTotalPrice: function (prices, priceDisplay) {
        var _a;
        return (_a = prices) === null || _a === void 0 ? void 0 : _a.find(function (price) {
            var _a, _b;
            if (dealPriceAccessor.hasSecondaryCurrency(priceDisplay)) {
                return (price.currency === ((_a = priceDisplay.primary) === null || _a === void 0 ? void 0 : _a.currency) && price.type === DealPriceType_1.DealPriceType.VEHICLE_TOTAL);
            }
            return ((_b = price) === null || _b === void 0 ? void 0 : _b.type) === DealPriceType_1.DealPriceType.VEHICLE_TOTAL;
        });
    },
    getSecondaryTotalPrice: function (prices, priceDisplay) {
        var _a;
        return (_a = prices) === null || _a === void 0 ? void 0 : _a.find(function (price) {
            var _a, _b;
            if (dealPriceAccessor.isMultiCurrency(priceDisplay)) {
                return (price.currency === ((_a = priceDisplay.secondary) === null || _a === void 0 ? void 0 : _a.currency) && price.type === DealPriceType_1.DealPriceType.VEHICLE_TOTAL);
            }
            return ((_b = price) === null || _b === void 0 ? void 0 : _b.type) === DealPriceType_1.DealPriceType.VEHICLE_TOTAL;
        });
    },
};
exports.default = dealPriceAccessor;
